import React from "react";
import { useHistory } from "react-router-dom";
import { Col, Button, Panel } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";
import {ReactComponent as MultiIcon}  from '../assets/multi.svg'
import {ReactComponent as QuestionIcon} from '../assets/question.svg'
import Loader from "./Loader";
import './RHS.css'

export default function RHS({
  communities,
  community,
  myCommunities,
  user
}) {
  const history = useHistory();

  return (communities?.length || myCommunities?.length) && history && user && 
    community && (user.admin || (community.moderator && community.moderator.includes(user.UID))) ? (
    <Col xs={12}>
      { history.location.pathname !== "/home" && community !== null ?
        (
          <Panel className="ask-card">
            <div className="ask-header">
              Moderator options
            </div>
            <Panel.Body style={{paddingTop: '5px', paddingBottom: '24px'}}>
              <LinkContainer className="ask-link" to={`/build?keyword=${community ? community.keyword : "SELECT A COMMUNITY"}&type=poll`} onClick={() => {this.forceUpdate()}}>
                <Button className="vote-btn">
                  <MultiIcon className="icon"/> create a poll
                </Button>
              </LinkContainer>
              <LinkContainer className="ask-link" to={`/build?keyword=${community ? community.keyword : "SELECT A COMMUNITY"}&type=question`} onClick={() => {this.forceUpdate()}}>
                <Button className="vote-btn">
                  <QuestionIcon className="icon"/> ask a question
                </Button>
              </LinkContainer>
            </Panel.Body>
          </Panel>
        )
      : null }
      <div
        key="footer"
        xs={12}
        style={{
            width: '272px',
            textAlign: 'center',
            fontSize: '11px',
            color: '#67768f',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
        }}
        >
        <div>
          <a className="link" href="mailto:team@icitizen.com">
            <span>Contact Us</span>
          </a>
          ⋅
          <LinkContainer className="link" to="/privacy">
            <span>Privacy</span>
          </LinkContainer>
          ⋅
          <LinkContainer className="link" to="/terms">
            <span>Terms</span>
          </LinkContainer>
        </div>
        <div style={{marginTop: '9px'}}>
          © 2024 icitizen. All Rights Reserved
        </div>
      </div>
    </Col>
  ) : <></>;
}